<wdx-icon-button [size]="'sm'" [attr.data-cy]="cySelector" (click)="onClick()">
    <wdx-icon [icon]="'copy'" [attr.alt]="'copy to clipboard'"></wdx-icon>
</wdx-icon-button>
